module.exports = __webpack_public_path__ + "img/wordle-1.0a55dc05.svg";